import { toNumber } from '../../utils/Utils';

export const TRANSLATIONS: Record<string, Record<string, string>> = {
  current_assets: {
    current_investments: 'Inversiones corrientes PF',
    cash_and_cash_equivalents: 'Disponibilidades',
    trade_receivables_short_term: 'Créditos por ventas CP',
    other_receivables: 'Otros créditos',
    inventory_short_term: 'Bienes de cambio - CP',
    other_current_assets: 'Otros activos corrientes - CP',
  },
  non_current_assets: {
    trade_receivables_long_term: 'Créditos por ventas LP',
    other_receivables: 'Otros créditos',
    permanent_investments: 'Inversiones permanentes',
    property_plant_and_equipment: 'Bienes de uso',
    other_non_current_assets: 'Otros activos no corrientes',
  },
  current_liabilities: {
    trade_payables_short_term: 'Deudas comerciales CP',
    bank_and_financial_debt_short_term: 'Deuda bancaria y financiera CP',
    social_security_debt_short_term: 'Deudas cargas sociales CP',
    tax_liabilities_short_term: 'Cargas fiscales CP',
    other_debts_provisions: 'Otras deudas - provisiones',
    projections: 'Proyecciones',
    other_liabilities: 'Otros pasivos',
  },
  non_current_liabilities: {
    non_current_liabilities: 'Pasivo no corriente',
    trade_payables_long_term: 'Deudas comerciales LP',
    bank_and_financial_debt_long_term: 'Deuda bancaria y financiera LP',
    social_security_debt_long_term: 'Cargas sociales LP',
    tax_liabilities_long_term: 'Cargas fiscales LP',
    other_long_term_liabilities: 'Otros pasivos LP',
  },
  net_worth: {
    capital: 'Capital',
    legal_reserves: 'Reservas Legales',
    other_reserves: 'Otras Reservas',
    capital_adjustment: 'Ajuste de Capital',
    irrevocable_contributions: 'Aportes Irrevocables',
    technical_revaluation: 'Revalúo Técnico',
    prior_accumulated: 'Acumuladas Ejercicio Anterior',
    result_of_period: 'Resultado del Ejercicio',
    other: 'Otros',
    other_components: 'Otros',
  },
  gross_result: {
    agricultural_production: 'Producción agropecuaria',
    production_cost: 'Costo de producción',
    sales: 'Ventas',
    cost_of_sales: 'Costo de ventas',
  },
  operating_result: {
    commercialization_expenses: 'Gastos de comercialización',
    administrative_expenses: 'Gastos de administración',
    other_income: 'Otros ingresos',
    other_expenses: 'Otros egresos',
  },
  ordinary_result: {
    financial_expenses: 'Gastos financieros',
    exchange_difference_and_holding_result: 'Dif. de cambio + res. tenencia',
  },
  result_before_taxes: {
    extraordinary_income: 'Ingresos extraordinarios',
    extraordinary_expenses: 'Egresos extraordinarios',
    total: 'Total',
  },
  taxes: { income_tax: 'Impuesto a las ganancias' },
};

export function getTranslation(category: string, label: string): string {
  return TRANSLATIONS[category]?.[label] ?? label;
}

export function transformObject(obj: any): any[] {
  if (!obj || typeof obj !== 'object') return [];
  return Object.entries(obj).map(([key, value]) =>
    typeof value === 'object' && value !== null
      ? { category: key, values: transformObject(value) }
      : { label: key, value }
  );
}

export function sumCategory(data: any, category: string): number {
  const obj = data?.[category];
  if (!obj || typeof obj !== 'object') return 0;
  const sum = Object.values(obj).reduce((a: number, b: any) => a + toNumber(b || 0), 0);
  return Math.round(sum);
}

export type DualRow = {
  label: string;
  valuePrev: string | number;
  valueCurr: string | number;
  isBold?: boolean;
};

export function getMergedValues(
  currTransformed: any[],
  prevTransformed: any[],
  category: string
): { label: string; valuePrev: string | number; valueCurr: string | number }[] {
  const currCat = currTransformed.find((c: any) => c.category === category)?.values ?? [];
  const prevCat = prevTransformed.find((c: any) => c.category === category)?.values ?? [];
  return currCat.map((curr: any, i: number) => ({
    label: curr.label,
    valuePrev: prevCat[i]?.value ?? curr.value ?? 0,
    valueCurr: curr.value ?? 0,
  }));
}
